import { jsx as _jsx } from "react/jsx-runtime";
import { TableContainer } from '@/core/ui';
import { createVirtuosoTableComponents } from '@/shared/components';
import { getItemWorkflowTableRowState } from '@/shared/helpers';
import { forwardRef } from 'react';
import { ItemWorkflowTableRow } from './components';
export function createItemWorkflowTableComponents() {
    return createVirtuosoTableComponents({
        components: {
            Scroller: forwardRef(({ children, context, ...props }, ref) => (_jsx(TableContainer
            // TODO: to delete `item-workflow-table-container` from everywhere. Now `focus` is used properly.
            // How it can be fixed? `listRef.current.focus()` doesn't work. Only `document.getElementById(id)` is working.
            , { 
                // TODO: to delete `item-workflow-table-container` from everywhere. Now `focus` is used properly.
                // How it can be fixed? `listRef.current.focus()` doesn't work. Only `document.getElementById(id)` is working.
                id: "item-workflow-table-container", ...props, ref: ref, 
                // Makes it possible to be focused by `listRef.current.focus()` method.
                tabIndex: -1, onMouseDown: () => { }, onFocus: () => {
                    if (context.currentItemIndex === -1)
                        context.setCurrentItemIndex(0);
                }, onBlur: () => { }, children: children }))),
            TableRow: ({ item: receiptItem, context, ...props }) => {
                const { currentItemIndex: contextCurrentItemIndex, onRowDoubleClick, setCurrentItemIndex } = context;
                return (_jsx(ItemWorkflowTableRow, { hover: true, ...props, rowState: getItemWorkflowTableRowState(receiptItem.quantity, 'receiptedQuantity' in receiptItem ? receiptItem.receiptedQuantity : receiptItem.pickedQuantity, 'blockedQuantity' in receiptItem ? receiptItem.blockedQuantity : undefined), selected: contextCurrentItemIndex === props['data-item-index'], onClick: () => {
                        setCurrentItemIndex(props['data-item-index']);
                    }, onDoubleClick: () => onRowDoubleClick?.(receiptItem) }));
            },
        },
    });
}
